/**
 * CUSTOMER FIX Stage 7 — deterministic tenant cart accent color.
 * Secondary identifier only — always pair with tenant name / initial in UI.
 */

const TENANT_COLOR_PALETTE = [
  '#0d9488',
  '#2563eb',
  '#7c3aed',
  '#db2777',
  '#ea580c',
  '#ca8a04',
  '#059669',
  '#4f46e5',
] as const;

function hashTenantCode(tenantCode: string): number {
  let hash = 0;
  for (let i = 0; i < tenantCode.length; i += 1) {
    hash = (hash * 31 + tenantCode.charCodeAt(i)) >>> 0;
  }
  return hash;
}

/** Stable accent for a tenant cart (not the sole cart identifier). */
export function resolveTenantCartColor(tenantCode: string): string {
  const normalized = tenantCode.trim().toLowerCase();
  if (normalized.length === 0) {
    return TENANT_COLOR_PALETTE[0];
  }
  const index = hashTenantCode(normalized) % TENANT_COLOR_PALETTE.length;
  return TENANT_COLOR_PALETTE[index] ?? TENANT_COLOR_PALETTE[0];
}

/** Single-letter initial for switcher rows (accessibility companion to color). */
export function resolveTenantCartInitial(
  tenantName: string,
  tenantCode: string,
): string {
  const fromName = tenantName.trim();
  if (fromName.length > 0) {
    return fromName.charAt(0).toUpperCase();
  }
  const fromCode = tenantCode.trim();
  if (fromCode.length > 0) {
    return fromCode.charAt(0).toUpperCase();
  }
  return '?';
}
